export default "__VITE_ASSET__4a67304f__"